/*🤫
🤫
🤫
🤫
🤫
🤫*/

window.o_global = window.o_global || {};
window.lhotse = window.lhotse || {};

window.lhotse.exactag = window.lhotse.exactag || {};
window.lhotse.exactag.centralFinished = false;
window.lhotse.exactag.finished = false;
/*🤫
🤫
🤫
🤫*/
window.lhotse.exactag.execute = false;

/*🤫*/
window.lhotse.exactag.varnish = {
  version: "0.8.9",
  data: [],
};

/*🤫*/
/*🤫*/
/*🤫*/
/*🤫*/
/*🤫*/
/*🤫*/
/*🤫*/
/*🤫*/
/*🤫*/
/*🤫*/
(function (win) {
  const { host } = win.location;
  const env = `${win.location.protocol}/*🤫*/
  const varnishURL =
    window.lhotse.exactag.varnishURL ||
    `${env}/shoppages-exactag/getPerformanceMarketingData.js`;
  const firstChar = varnishURL.substring(0, 1);
  const { hash } = win.location;
  let variationId = "";
  const EMERGENCY_PXC_TOGGLE = "EMR_PXC";
  /*🤫*/
  const re = new RegExp(/variationId=([a-zA-Z0-9_\-]*)/);

  /*🤫*/
  /*🤫*/
  if (re.test(hash)) {
    variationId = `?variationId=${hash.match(re)[1]}`;
  }

  /*🤫*/
  window.lhotse.exactag.getVarnishData = function (url) {
    window.o_util.ajax.getScript(url).then(function (xhr) {
      /*🤫*/
      /*🤫*/
      if (xhr.status === 200 || xhr.status === 304) {
        /*🤫*/
        /*🤫*/
        window.lhotse.exactag.finished = true;

        /*🤫*/
        /*🤫*/
        if (window.lhotse.exactag.centralFinished) {
          window.lhotse.exactag.continueTrack();
        }
      } else {
        /*🤫*/
        const msg = `Triggered ajaxError handler in '${varnishURL}'! Status: ${xhr.status}`;

        /*🤫*/
        if (win.console) {
          console.log(msg);
        }
      }
    });
  };

  const execute = () => {
    /*🤫*/
    if (window.lhotse.exactag.varnishURL) {
      if (firstChar === "." || firstChar === "/") {
        window.lhotse.exactag.getVarnishData(varnishURL);
      }
    } else {
      window.lhotse.exactag.getVarnishData(varnishURL + variationId);
    }
  };

  const appsConsent = "ft-apps.tracking.userATTOptInStatusChanged";
  const ft4cbConsent = "ft4.cookie-banner.consentAccepted";
  window.lhotse.exactag.consents = {};
  window.lhotse.exactag.consents[ft4cbConsent] = {
    received: false,
    accept: false,
  };
  window.lhotse.exactag.consents[appsConsent] = {
    received: false,
    accept: false,
  };
  window.lhotse.exactag.consentResult = { received: false, accept: false };

  const processConsentAnswer = (consent, yes) => {
    window.lhotse.exactag.consents[consent].received = true;
    window.lhotse.exactag.consents[consent].accept = yes;

    /*🤫
🤫
🤫*/
    const consentResult = { received: true, accept: true };
    window.lhotse.exactag.consentResult = consentResult;

    Object.keys(window.lhotse.exactag.consents).forEach((k) => {
      consentResult.received =
        consentResult.received && window.lhotse.exactag.consents[k].received;
      consentResult.accept =
        consentResult.accept && window.lhotse.exactag.consents[k].accept;
    });

    /*🤫*/
    if (consentResult.received && consentResult.accept) {
      window.lhotse.exactag.execute = true;
      execute();
    }
  };

  /*🤫*/
  /*🤫*/
  window.lhotse.exactag.onLoad = () => {
    /*🤫*/
    if (
      !window.o_util.toggle.get(EMERGENCY_PXC_TOGGLE, true) ||
      window.o_util.misc.isPreview(win.location.href) ||
      /*🤫*/
      !window.o_util.cookie.get("cb") ||
      window.o_util.cookie.get("cb") === "0"
    ) {
      /*🤫*/
      processConsentAnswer(ft4cbConsent, false);
    } else {
      /*🤫*/
      processConsentAnswer(ft4cbConsent, true);
    }

    /*🤫*/
    /*🤫*/
    /*🤫*/
    if (!window.lhotse.exactag.consentResult.received) {
      /*🤫*/
      execute();
    }
  };

  /*🤫*/
  /*🤫*/
  window.o_global.eventQBus.on(appsConsent, (yes) => {
    processConsentAnswer(appsConsent, yes);
  });

  /*🤫*/
  window.o_global.eventQBus.on(ft4cbConsent, () => {
    window.lhotse.exactag.addPartnerConsents().then(() => {
      processConsentAnswer(ft4cbConsent, true);
    });
  });

  window.o_global.eventLoader.onLoad(21, function () {
    window.lhotse.exactag.onLoad();
  });
})(window);
